<template>
  <DetailWithIcon>
    <template #icon>
      <i class="icon-calendar" />
    </template>
    <template #detail-text>
      {{ i18n.l(i18nFormat, startDate) }} &mdash;
      {{ i18n.l(i18nFormat, endDate) }}
    </template>
  </DetailWithIcon>
</template>

<script>
import DetailWithIcon from './detail-with-icon'

export default {
  components: {
    DetailWithIcon
  },
  props: {
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    },
    i18nFormat: {
      type: String,
      default: 'time.formats.date_medium'
    }
  }
}
</script>
